module.exports = __webpack_public_path__ + "static/media/ace3.d0ce61a4.jpg";